export default __webpack_public_path__ + "media/images/icons/check-circle-regular-f1ff1dd896cfa47cb946bbaa85b294d7.svg";